export default "__VITE_ASSET__DJbAUYeX__"